import { Directive, ElementRef, HostListener, Input, OnChanges } from '@angular/core';

import { ChainFocusDirective } from './chain-focus.directive';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[appChainFocusItem]',
    standalone: true
})
export class ChainFocusItemDirective implements OnChanges {
  constructor(
    private elRef: ElementRef,
    private chainWrapper: ChainFocusDirective,
    private control: NgControl,
  ) {}

  @Input() inputLength: number = 1;

  @Input() clearForm: boolean;

  private _index: number;

  set index(index: number) {
    this._index = index;
  }

  setValue(value: string | number): void {
    this.control.control?.setValue(value);
  }

  setActive(): void {
    this.elRef.nativeElement.focus();
  }

  ngOnChanges(): void {
    if (this.clearForm) {
      this.chainWrapper.firstItem();
    }
  }

  @HostListener('input')
  onInput(): void {
    if (this.elRef.nativeElement.value.length < this.inputLength) {return}
    this.chainWrapper.nextItem();
  }

  @HostListener('keydown.backspace')
  onKeydown(): void {
    if (this.elRef.nativeElement.value == '') {
      this.chainWrapper.prevItem();
    }
  }

  @HostListener('focus')
  onFocus(): void {
    this.chainWrapper.setCurrentIndex(this._index);
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    if (event && event.clipboardData) {
      const code = event.clipboardData?.getData('text');
      const codeArray = code?.split('');
      this.chainWrapper.setFullCode(codeArray);
    }
  }
}
